import { useMemo } from 'react';
import { useGetReferralPartnerClientCountsQuery } from '@/features/clients/clientsApi';

const EMPTY_CONTACTS = [];
const EMPTY_REFERRAL_COUNTS = {};

export const getReferrerEmail = (contact) => {
	if (contact?.relationshipType !== 'referrer' || !contact.email) {
		return null;
	}
	return contact.email.trim().toLowerCase();
};

export const useGetReferralPartnerClientCounts = (contacts = EMPTY_CONTACTS) => {
	const referrerEmails = useMemo(
		() => [...new Set(contacts.map(getReferrerEmail).filter(Boolean))],
		[contacts],
	);
	const referralCountsQuery = useGetReferralPartnerClientCountsQuery(referrerEmails, {
		skip: referrerEmails.length === 0,
	});
	const referralCountsLoading =
		referrerEmails.length > 0 &&
		(referralCountsQuery.isUninitialized || referralCountsQuery.isLoading);

	return {
		referralCounts: referralCountsQuery.data ?? EMPTY_REFERRAL_COUNTS,
		referralCountsLoading,
	};
};
